module.exports = __webpack_public_path__ + "img/screen11@2x.6941cd2e.jpg";